import React, { memo, useMemo } from 'react';

import type { ViewportRenderProps } from '@/components/atomic/molecules/utils/viewport/viewport-render/typings';
import useStore from '@/state';
import getMaxBreakpointLowerThan from '@/state/selectors/window/get-max-breakpoint-lower-than';
import { IStore } from '@/state/slices/typings';
import { typedObjectKeys } from '@multitenancy-spa/utils/esm/utils/typed-object-keys';

const ViewportRenderComponent: React.FC<ViewportRenderProps> = ({
	Component,
	componentProps,
	node,
	$breakpoints,
}) => {
	const breakpointsKeys = useMemo(() => {
		if (!$breakpoints) return [];
		return typedObjectKeys($breakpoints).map(Number);
	}, [$breakpoints]);

	const maxBreakpoint = useStore((state: IStore) =>
		getMaxBreakpointLowerThan(state, breakpointsKeys),
	);

	const breakpoint = useMemo(
		() => $breakpoints?.[maxBreakpoint],
		[maxBreakpoint, $breakpoints],
	);

	if (breakpoint) {
		const {
			Component: BreakpointComponent,
			componentProps: breakpointComponentProps,
			node: breakpointNode,
		} = breakpoint;
		if (BreakpointComponent) {
			return (
				<BreakpointComponent {...(breakpointComponentProps ?? {})} />
			);
		}
		if (breakpointNode) {
			return <>{breakpointNode}</>;
		}
	}

	if (Component) return <Component {...(componentProps ?? {})} />;

	if (node) return <>{node}</>;

	return null;
};

const ViewportRender = memo(ViewportRenderComponent);

export default ViewportRender;
